import axiosInstance from '../axiosConfig';
import Config from '../../config/config';

const defineEnv = Config;

export default {
  async validateBillling(payload) {
    const response = await axiosInstance.post(
      'EcomValidarFacturaPedido',
      payload
    );
    return response.data;
  },
  async getFiscalRegimes(payload) {
    const url =
      '../../../QAapi-foreverliving/Ecomm/fbosite/fboinfo/api/ListaRegimen';
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'x-flpmx-auth-token': defineEnv.api_services.token,
          'Content-Type': 'application/json',
        },
      });
      return await response.json();
    } catch (err) {
      console.log(err);
      return null;
    }
  },
  async getCfdiList(payload) {
    const url =
      '../../../QAapi-foreverliving/Ecomm/fbosite/fboinfo/api/ListaUsoCfdi';
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'x-flpmx-auth-token': defineEnv.api_services.token,
          'Content-Type': 'application/json',
        },
      });
      return await response.json();
    } catch (err) {
      console.log(err);
      return null;
    }
  },
  async billOrder(payload) {
    const response = await axiosInstance.post(
      'EcomTimbrarFacturaPedido',
      payload
    );
    return response.data;
  },
  async setBillingAddress(payload) {
    const response = await axiosInstance.post(
      'EcomAgregarDatosFacturacion',
      payload
    );
    return response.data;
  },
};
